<template>
  <div>
    <v-btn
      v-for="item in items"
      :key="item.Id_Tecla"
      rounded
      small
      class="ma-2"
      v-shortkey.once="[item.TeclaFuncion.toLowerCase()]"
      @shortkey="buscarTecla(item.Id_Tecla)"
      @click="buscarTecla(item.Id_Tecla)"
    >
      <v-badge color="primary" :content="item.TeclaFuncion">
        <small>
          {{ formatearNombre(item.NombreArticulo) }}
          <small>
            <br />
            {{ item.Contado | esMoneda }}
          </small>
        </small>
      </v-badge>
    </v-btn>
  </div>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
export default {
  name: "NavBarArticulo",
  props: {
    id_PuntoVenta: Number
  },
  data() {
    return {
      boton: "",
      items: []
    };
  },
  watch: {
    id_PuntoVenta: function() {
      this.listarItems();
    }
  },
  created() {
    this.listarItems();
  },
  methods: {
    listarItems() {
      if (this.id_PuntoVenta) {
        this.loading = true;
        HttpHelper.get("Tecla/ListarPorPuntoVenta", {
          id: this.id_PuntoVenta
        })
          .then(response => {
            this.items = response.data;
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    },
    buscarTecla(valor) {
      var ind = this.items.findIndex(x => x.Id_Tecla == valor);
      this.boton = this.items[ind].TeclaFuncion;
      this.$emit("seleccionarItem", this.items[ind]);
    },
    formatearNombre(nombre) {
      return nombre.length > 20 ? nombre.substring(0, 20) : nombre;
    }
  }
};
</script>
